import { render, staticRenderFns } from "./questionAnswers.vue?vue&type=template&id=0df7c164&scoped=true&"
import script from "./questionAnswers.vue?vue&type=script&lang=js&"
export * from "./questionAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7c164",
  null
  
)

export default component.exports